export const getLocation = state => state.getIn(['app', 'location']);
export const getIsLoading = state => state.getIn(['app', 'isLoading']);
export const getIsSnackbarOpen = state => state.getIn(['app', 'isSnackbarOpen']);
export const getSnackbarQueue = state => state.getIn(['app', 'snackbarQueue']);
export const getSnackbarMessage = state => state.getIn(['app', 'snackbarQueue', 0, 'message'], '');
